module.exports = __webpack_public_path__ + "email-header.png";